var ROOT = 'ray-dropdown';
export var CLASSNAMES = {
  root: "".concat(ROOT),
  inputElement: "".concat(ROOT, "__input"),
  wrapper: "".concat(ROOT, "__wrapper"),
  label: "".concat(ROOT, "__label"),
  body: "".concat(ROOT, "__body"),
  selected: "".concat(ROOT, "__selected"),
  selectedValue: "".concat(ROOT, "__selected-value"),
  clear: "".concat(ROOT, "__selected-clear"),
  container: "".concat(ROOT, "__option-container"),
  list: "".concat(ROOT, "__option-list"),
  option: "".concat(ROOT, "__option"),
  separator: "".concat(ROOT, "__option--separator"),
  placeholder: "".concat(ROOT, "__option--placeholder"),
  optionSelected: "".concat(ROOT, "__option--selected"),
  groupLabel: "".concat(ROOT, "__option--group-label"),
  OPEN: "".concat(ROOT, "--open"),
  ACTIVE: "".concat(ROOT, "--active"),
  REQUIRED: "".concat(ROOT, "--required"),
  DISABLED: "".concat(ROOT, "--disabled"),
  PLACEHOLDER_MODE: "".concat(ROOT, "--placeholder-mode"),
  HAS_VALUE: "".concat(ROOT, "--has-value")
};
export var SELECTORS = {
  INIT_SELECTOR: ".".concat(ROOT),
  root: ".".concat(CLASSNAMES.root),
  inputElement: ".".concat(CLASSNAMES.inputElement),
  wrapper: ".".concat(CLASSNAMES.wrapper),
  label: ".".concat(CLASSNAMES.label),
  body: ".".concat(CLASSNAMES.body),
  selected: ".".concat(CLASSNAMES.selected),
  selectedValue: ".".concat(CLASSNAMES.selectedValue),
  clear: ".".concat(CLASSNAMES.clear),
  container: ".".concat(CLASSNAMES.container),
  list: ".".concat(CLASSNAMES.list),
  option: ".".concat(ROOT, "__option"),
  separator: ".".concat(ROOT, "__option--separator"),
  placeholder: ".".concat(ROOT, "__option--placeholder")
};
export var bodyTpl = function bodyTpl(_ref) {
  var value = _ref.value;
  return {
    position: 'beforebegin',
    selector: SELECTORS.body,
    tpl: "\n      <div class=\"".concat(CLASSNAMES.body, "\" tabindex=\"0\">\n        <div class=\"").concat(CLASSNAMES.selected, "\">\n          <span class=\"").concat(CLASSNAMES.selectedValue, "\">").concat(value, "</span>\n        </div>\n      </div>\n    "),
    elements: ['body', 'selectedValue']
  };
};
export var listTpl = function listTpl(_ref2) {
  var id = _ref2.id;
  return {
    position: 'afterend',
    selector: SELECTORS.container,
    tpl: "\n      <div class=\"".concat(CLASSNAMES.container, "\" aria-expanded=\"false\">\n        <ul\n          role=\"listbox\"\n          class=\"").concat(CLASSNAMES.list, "\"\n          id=\"").concat(id, "-list\"\n        >\n        </ul>\n      </div>\n    "),
    elements: ['container', 'list']
  };
};
export var separatorTpl = "<li disabled class=\"".concat(CLASSNAMES.option, " ").concat(CLASSNAMES.separator, "\" />");
export var placeholderTpl = "<li data-ray-idx=\"0\" class=\"".concat(CLASSNAMES.option, " ").concat(CLASSNAMES.placeholder, "\" />");
export var optionId = function optionId(_ref3) {
  var id = _ref3.id,
      idx = _ref3.idx;
  return "".concat(id, "-option-").concat(idx);
};
export var optionTpl = function optionTpl(_ref4) {
  var label = _ref4.label,
      id = _ref4.id,
      idx = _ref4.idx,
      selected = _ref4.selected,
      disabled = _ref4.disabled;
  return "\n    <li\n      role=\"option\"\n      data-ray-idx=\"".concat(idx, "\"\n      id=\"").concat(optionId({
    id: id,
    idx: idx
  }), "\"\n      ").concat(disabled ? 'disabled' : '', "\n      class=\"").concat(CLASSNAMES.option).concat(selected ? CLASSNAMES.optionSelected : '', "\"\n    >\n    ").concat(label, "\n  </li>\n");
};
export var groupLabelTpl = function groupLabelTpl(_ref5) {
  var label = _ref5.label,
      disabled = _ref5.disabled;
  return "\n    <li\n      role=\"option\"\n      ".concat(disabled ? 'disabled' : '', "\n      class=\"").concat(CLASSNAMES.groupLabel, "\"\n    >\n      ").concat(label, "\n    </li>\n  ");
};
export var markupTemplates = [bodyTpl, listTpl];